module.exports = __webpack_public_path__ + "static/media/sitting_right_hand_midline_crossing.7ca3a82f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/quick-play-icons/sitting_right_hand_midline_crossing.png
// module id = 723
// module chunks = 0